import React from "react";
import { ProductVisual } from "./ProductVisual";
import { Container, CtaButton } from "./ui";
import { checkout, hero } from "../data/content";
export function Hero() {
  return <header id="hero" className="bg-cream pb-10 pt-6 text-ink md:pb-16 md:pt-12" data-id="element-80" data-mp="9kjwmolen43o">
      <Container className="flex flex-col gap-5 lg:grid lg:grid-cols-[1.1fr_1fr] lg:items-center lg:gap-x-12 lg:gap-y-5" data-id="element-81" data-mp="9igux7aw3mj4">
        <div className="order-1 text-center lg:col-start-1 lg:row-start-1 lg:self-end lg:text-left" data-id="element-82" data-mp="12a0mbehn46w7">
          <p className="inline-flex items-center gap-2 rounded-full border border-petrol/40 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-petrol sm:text-xs" data-id="element-83" data-mp="x9ur5oc5w29d">
            <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-petrol" aria-hidden="true" data-id="element-84" data-mp="nc87kojx3mj2" />
            {hero.eyebrow}
          </p>
          <h1 className="mt-4 font-display text-[clamp(40px,11vw,58px)] font-extrabold uppercase leading-[0.92] tracking-[-0.01em] lg:text-[clamp(60px,6vw,86px)]" data-id="element-85" data-mp="3d2labedjz91r">
            Your next activity, <span className="text-petrol" data-id="element-86" data-mp="3j7zc59vbxccg">ready to lead.</span>
          </h1>
          <p className="mx-auto mt-3 max-w-[520px] text-lg font-semibold text-ink lg:mx-0 lg:text-xl" data-id="element-87" data-mp="3o7lq5lizewmb">{hero.promise}</p>
        </div>

        <div className="order-2 lg:col-start-2 lg:row-span-3 lg:row-start-1" data-id="element-88" data-mp="399b9pjftv5tv">
          <ProductVisual data-id="element-89" data-mp="3e8wkqs89v4my" />
        </div>

        <div className="order-3 text-center lg:col-start-1 lg:row-start-3 lg:self-start lg:text-left" data-id="element-90" data-mp="3e7uvnjuf8hm8">
          <CtaButton href="#offer-details" className="w-full sm:w-auto" data-id="element-91" data-mp="30ggab6d1k4c0">
            Get my activity kit — ${checkout.price}
          </CtaButton>
          <p className="mt-2 text-[13px] text-muted sm:text-sm" data-id="element-92" data-mp="2qk3m2o09mion">{hero.trust}</p>
        </div>

        <p className="order-4 text-center text-base text-muted lg:col-start-1 lg:row-start-2 lg:max-w-[560px] lg:text-left lg:text-lg" data-id="element-93" data-mp="2vion2pncd6e5">
          {hero.explanation}
        </p>
      </Container>
    </header>;
}